import * as React from 'react';
import { useSelector } from 'react-redux';
import { getSpecialPromos } from '../../selectors/developerV2';
import { PromoCardRedesign } from '../../components/PromoCardRedesign';
import { ISpecialPromo } from '../../types/specialPromos/specialPromos';
import { PromoDetailsModal } from '../../components/PromoDetailsModal';
import { NewbuildingLinksList } from '../../components/PromoDetailsModal/components/NewbuildingLinksList';
import { OffersLink } from '../../components/PromoDetailsModal/components/OffersLink';
import { trackOpenDiscount } from './tracking';

export const SpecialPromosRedesign = () => {
  const specialPromos = useSelector(getSpecialPromos);

  const promos = specialPromos?.promos;

  const [currentPromo, setCurrentPromo] = React.useState<ISpecialPromo | null>(null);
  const [isOpen, setIsOpen] = React.useState(false);

  const onPromoClick = React.useCallback((promo: ISpecialPromo) => {
    setIsOpen(true);
    setCurrentPromo(promo);
    trackOpenDiscount(promo.promoType);
  }, []);

  const closePromoDetailsModal = React.useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  if (!promos) {
    return null;
  }

  return (
    <>
      {promos.map(promo => (
        <PromoCardRedesign key={promo.uniquePromoId} promo={promo} onClick={() => onPromoClick(promo)} />
      ))}
      {isOpen && currentPromo?.promoPopup && (
        <PromoDetailsModal
          onClose={closePromoDetailsModal}
          promoName={currentPromo.promoName}
          providerName={currentPromo.providerName}
          logo={currentPromo.providerLogo}
          features={currentPromo.promoProps}
          description={currentPromo.promoPopup.promoDescription}
          banks={currentPromo.promoPopup.banks}
          newbuildingLinksList={
            <NewbuildingLinksList
              newbuildingCountText={currentPromo.promoPopup.newbuildingCountText}
              newbuildingCountLink={currentPromo.promoPopup.newbuildingCountLink}
              newbuildingLinks={currentPromo.promoPopup.newbuildingLinks}
            />
          }
          linkButton={
            !!currentPromo.promoPopup.newbuildingCountLink && (
              <OffersLink url={currentPromo.promoPopup.newbuildingCountLink} />
            )
          }
        />
      )}
    </>
  );
};
